import { useMemo } from "react";
import type { BulkEditOptions, Option } from "./BulkEditPopup";
import { useSuppliers } from "../../../../Components/InvoiceEditor/supplierList";
import { useCategories } from "../../../../Components/InvoiceEditor/categoryList";
import {
  currencies, invoiceTypes, paymentMethods, yesNo, comboboxOption,
} from "../../../../Components/InvoiceEditor/constants";

const fromStrings = (list: string[]): Option[] =>
  list.map((s) => ({ value: s, label: s }));

// The edit form stores the option NAME as the value (and the id separately),
// so value = optionName here too.
const fromCombobox = (list: comboboxOption[]): Option[] =>
  list.map((o) => ({ value: o.optionName, label: o.optionName, id: o.optionId }));

export const useBulkEditOptions = (): BulkEditOptions => {
  const suppliers = useSuppliers();
  const categories = useCategories();

  return useMemo(
    () => ({
      type: fromStrings(invoiceTypes),
      supplier: fromCombobox(suppliers),
      category: fromCombobox(categories),
      currency: fromCombobox(currencies),
      paid: fromStrings(yesNo),
      paymentMethod: fromStrings(paymentMethods),
    }),
    [suppliers, categories],
  );
};
